import React, { useState, useEffect } from "react";
import { Clock, Loader2 } from "lucide-react";
import { academicService } from "../../services/academicService";

export const SemesterConfigurationPage: React.FC = () => {
  const [semesters, setSemesters] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSemesters();
  }, []);

  const fetchSemesters = async () => {
    try {
      const data = await academicService.getSemesters();
      setSemesters(data.results || data || []);
    } catch {
      setSemesters([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-5 bg-slate-900/90 border border-slate-800 rounded-xl shadow-md text-xs font-sans space-y-4">
      <div className="flex items-center justify-between pb-3 border-b border-slate-800">
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-indigo-400" />
          <h2 className="text-base font-bold text-slate-100">Semester Registration & Examination Windows</h2>
        </div>
      </div>

      {loading ? (
        <div className="p-8 text-center text-slate-400 text-xs flex items-center justify-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin text-indigo-400" /> Loading Semesters...
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {semesters.map((s) => (
            <div key={s.id} className="p-4 bg-slate-950/90 border border-slate-800 rounded-xl space-y-2 font-mono">
              <div className="flex items-center justify-between">
                <span className="text-[10px] font-bold text-indigo-400 bg-indigo-950 px-2 py-0.5 rounded border border-indigo-900">
                  Semester {s.number || s.sequence || 1}
                </span>
                <span className="text-[10px] text-slate-400 font-sans font-bold">{s.program_name || s.name}</span>
              </div>
              <div className="text-slate-300 text-[11px] space-y-1 pt-1 font-sans">
                <div>Academic Status: <span className="font-mono text-emerald-300 font-bold">{s.status || "Active"}</span></div>
              </div>
            </div>
          ))}
          {semesters.length === 0 && (
            <div className="md:col-span-2 p-8 text-center text-slate-500 font-sans border border-slate-800 rounded-xl bg-slate-950">
              No active semester structures created for this institution yet.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
